import type { FeatureConfig } from '@skynet/feature-config';
import { MessageOutlined } from '@ant-design/icons';
import { BOT_MESSAGES_LIST_URL, BOT_MESSAGES_ROUTE_PATH } from './routes';

/**
 * Feature manifest for the Assistant Bot message history page. The dashboard
 * shell reads this single source of truth instead of hardcoding the route,
 * navigation entry, header label and Cerbos action across its routing,
 * navigation, header and access-control modules.
 *
 * `route.load` is a dynamic-import thunk, so importing this config for its
 * nav/header metadata never pulls the page implementation into the main bundle.
 *
 * The route path, nav url and WS-login skip path come from this package's own
 * `./routes`.
 */
export const botMessagesConfig = {
  domain: 'Admin',
  section: 'bot-messages',
  route: {
    path: BOT_MESSAGES_ROUTE_PATH,
    load: async () => ({ default: (await import('./BotMessages')).BotMessages }),
  },
  nav: {
    key: 'admin.bot-messages',
    label: 'Bot Messages',
    icon: <MessageOutlined />,
    url: BOT_MESSAGES_LIST_URL,
  },
  header: { label: 'Bot Messages' },
  cerbosAction: 'read:admin:bot-messages',
  needsEntityId: false,
  skipWsLoginPaths: [BOT_MESSAGES_LIST_URL],
} as const satisfies FeatureConfig;
